import React, { Component } from 'react';
import CoopCursorBorderMobile from '../../../coop-cursor-border-mobile';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import SelectGraphicLineMobile from '../../../element-types/connector-element/select-graphic-line-mobile';
import omit from 'lodash/omit';
import { omitStyle } from '@src/slide/infrastructure/module/independent/assert/get-set';
import * as commonFun from '../../../common';
import SelectedElementWrapperUtil from '../../selected-element-layer/utils';
import { GroupUIEdge } from '../../../element-types/group-element/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { reaction } from 'mobx';
import { disposeOnUnmount } from 'mobx-react';
import { ServicesContext } from '../../context';
import { ICursorManager } from '@src/slide/application/service/cursor-manager/core/cursor-manager.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

interface IProps {
    scale: number;
}

interface IStates {
    cursorManager: ICursorManager | undefined;
}

export default class CursorBorderMobile extends Component<IProps, IStates> {
    public static contextType = ServicesContext;

    declare public context: React.ContextType<typeof ServicesContext>;

    private instance: IDynamicService<ICursorManager> | undefined;

    public constructor(props, context) {
        super(props, context);
        this.state = {
            cursorManager: undefined,
        };
        this.instance = this.context.cursorManager;
    }

    public componentDidMount() {
        document.addEventListener('mousemove', this.handleMouseMove);
        this.instance?.promise().then((cursorManager) => {
            this.setState({
                cursorManager,
            });
            disposeOnUnmount(this, reaction(
                () => cursorManager.elementsWithCursors.length,
                () => {
                    this.setState({});
                },
            ));
        });
    }

    public componentWillUnmount() {
        document.removeEventListener('mousemove', this.handleMouseMove);
    }

    public handleMouseMove = async (e) => {
        const { clientX, clientY } = e;
        const elementsWithCursors = (await this.instance?.promise())?.elementsWithCursors;
        if (elementsWithCursors?.length === 0) {
            return null;
        }
        elementsWithCursors?.forEach((item) => {
            const cursorBorder = document.querySelector(`.cursor-border-${item.id}`) as HTMLDivElement;
            if (cursorBorder) {
                const rect = cursorBorder.getBoundingClientRect();
                const { top, left, width, height } = rect;
                if (!(clientX >= left && clientX <= left + width && clientY >= top && clientY <= top + height)) {
                    cursorBorder.style.pointerEvents = 'auto';
                }
            }
        });
    };

    public handleMouseEnter = async (element: IElementBaseModel, id) => {
        const cursorBorder = document.querySelector(`.cursor-border-${id}`) as HTMLDivElement;
        if (cursorBorder) {
            cursorBorder.style.pointerEvents = 'none';
        }
        this.context.cursorManager?.promise().then(cursorManager => cursorManager.showCursorTagForElement(element));
    };

    public handleMouseLeave = async (element: IElementBaseModel) => {
        this.context.cursorManager?.promise().then(cursorManager => cursorManager.hideCursorTagForElement(element));
    };

    // 找根组元素
    public getRootGroup = (element) => {
        let uiModel = element.parent;
        while (uiModel && !this.isRootGroup(uiModel)) {
            uiModel = uiModel.parent;
        }
        return uiModel;
    };

    public isRootGroup(uiModel) {
        return uiModel.type === UIModelType.GROUP && uiModel.isRootGroup;
    }

    public getCoopCursorBorder = (item) => {
        const elementModel = item.element;
        const { width, height } = elementModel.props.style;
        const isRootGroup = this.isRootGroup(elementModel);

        const innerRect = {
            width,
            height,
        };

        if (isRootGroup) {
            innerRect.width = width + (GroupUIEdge * 2);
            innerRect.height = height + (GroupUIEdge * 2);
        }

        return (
            <CoopCursorBorderMobile
                size={innerRect}
                scale={this.props.scale}
                color={item.cursor[0].color}
                shouldRoundSize={elementModel.type === UIModelType.SHAPE
                || elementModel.type === UIModelType.IMAGE}
            />
        );
    };

    public getSelectGraphicLine = (item, frame) => (
        <SelectGraphicLineMobile
            model={{
                ...omit(omitStyle(item.element.props.style), 'width', 'height'),
                width: frame.width,
                height: frame.height,
                points: item.element.props.points,
            }}
            strokeColor={item.cursor[0].color}
            strokeOpacity={0.7}
            scale={this.props.scale}
        />
    );

    public renderCursorBorder = (item) => {
        const elementModel = item.element;
        if (!this.state.cursorManager?.isElementInSlide(elementModel)) {
            return null;
        }

        let frameInfoForOuter = SelectedElementWrapperUtil.frameInfoForOuter(elementModel, true);
        const isRootGroup = this.isRootGroup(elementModel);
        let rootGroupFrame = {};
        if (elementModel.type === UIModelType.TABLE) {
            if (this.context.editingStateManager?.isResizing) {
                frameInfoForOuter = elementModel.getFrame?.().getFrameInfo(false);
            }
        }
        let transformInfo = SelectedElementWrapperUtil.transformForOuter(elementModel, false);
        if (elementModel.type === UIModelType.CONNECTOR) {
            transformInfo = commonFun.transformOfRotateAndFlip(frameInfoForOuter);
        }
        if (isRootGroup) {
            const rect = elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
            rootGroupFrame = {
                left: rect.left - GroupUIEdge,
                top: rect.top - GroupUIEdge,
                width: rect.width + (GroupUIEdge * 2),
                height: rect.height + (GroupUIEdge * 2),
            };
            Object.assign(frameInfoForOuter, rootGroupFrame);
        }
        const flag = browser.isMobile ? 'none' : 'auto';

        const style = {
            width: frameInfoForOuter.width * this.props.scale,
            height: frameInfoForOuter.height * this.props.scale,
            left: frameInfoForOuter.left * this.props.scale,
            top: frameInfoForOuter.top * this.props.scale,
        };

        return (
            !elementModel.selected ? <div
                className={`cursor-border-${item.id}`}
                key={item.id}
                style={{
                    ...style,
                    position: 'absolute',
                    transform: transformInfo,
                    pointerEvents: flag,
                }}
                onMouseEnter={() => this.handleMouseEnter(item.element, item.id)}
                onMouseLeave={() => this.handleMouseLeave(item.element)}
            >
                {
                    item.element.type === UIModelType.CONNECTOR
                        ? this.getSelectGraphicLine(item, style)
                        : this.getCoopCursorBorder(item)
                }
            </div> : null
        );
    };

    public render() {
        const elementsWithCursors = this.state.cursorManager?.elementsWithCursors;
        if (elementsWithCursors?.length === 0) {
            return null;
        }

        return (
            <React.Fragment>
                {
                    elementsWithCursors?.map(item => this.renderCursorBorder(item))
                }
            </React.Fragment>
        );
    }
}
